var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page home-page home-logistics"},[_c('navbar'),_c('logistics-sidebar'),_c('statistic-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }